export const localStorageKeys = {
  web3: 'WEB3_CONNECT_CACHED_PROVIDER',
  athleteStickersSelected: 'athleteStickersSelected',
  itemStickersSelected: 'itemStickersSelected',
  isRoseProfileCompleted: 'isRoseProfileCompleted',
  isLoadedMM: 'isLoadedMM',
  isAnimationDisabled: 'isAnimationDisabled',
}
